<!--Currently used to display the daily costs and savings summary on dashboard
on the DESS graph under the costs and savings tab-->
<template>
    <div class="history-tile">
        <div class="vrm-data-block vrm-data-block--justify">
            <div class="content with-bottom-padding">
                <div class="header header--small">
                    <div :class="iconColorClass">
                        <span :class="icon"></span>
                    </div>
                    <span>{{ this.$t(label, { i18nFallback: labelFallback }) }}</span>
                </div>
                <div class="summary">
                    <span>{{ sign }}</span>
                    {{ value }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-summary-dess-card')
export default class VrmSummaryDessCard extends Vue {
    @Prop()
    iconColorClass;
    @Prop()
    icon;
    @Prop()
    label;
    @Prop()
    labelFallback;
    @Prop()
    sign;
    @Prop()
    value;
}
</script>
